import { InfoCircleFilled } from '@ant-design/icons';
import { Card, theme } from 'antd';
import { useTranslation } from 'react-i18next';

export const ApplicationInReviewCard = () => {
	const { t } = useTranslation();
	const {
		token: { blue5 },
	} = theme.useToken();

	return (
		<Card
			title={
				<div className="flex row items-center">
					<div className="pr-[8px]">
						<InfoCircleFilled style={{ fontSize: '16px', color: blue5 }} />
					</div>
					<div className="pl-[8px]">{t('inReview')}</div>
				</div>
			}
		>
			<div className="flex row items-center">
				<div className="pl-[8px]">
					<p>{t('applicationYouSubmittedIsInReview')}</p>
					<p>{t('coordinatorsWillReachOutForScreening')}</p>
				</div>
			</div>
		</Card>
	);
};
